<template>
    <div>
        <Navbar/>
        <div id="registration">
            <div class="row pt-5 pb-2">
                <div class="col text-center">
                    <h1 class="lato-light">Registration</h1>
                </div>
            </div>
            <div class="row registration-content">
                <div class="col-12">
                    <iframe frameborder="0" width="100%" height="2000" src="https://affiliate.bitcoin.com/signup.html"></iframe>
                </div>
            </div>
        </div>
        <Footer isBackgroundImage="false"/>
    </div>
</template>

<script>
    import Navbar from "./Navbar";
    import Footer from "./Footer";
    import {doScroll} from '../assets/js/scroll';

    export default {
        name: "Registration",
        components: {
            Navbar,
            Footer
        },
        mounted() {
            this.doScroll('registration');
        },
        methods: {
            doScroll
        }
    }
</script>

<style scoped>
    .registration-content {
        min-height: 1230px;
        margin-left: 1rem;
        margin-right: 1rem;
    }
    #registration {
        height: 100%;
        background-position: center;
        background-repeat: no-repeat;
        background-size: 110%;
        margin-top:55px;
    }

    /*For Desktop/Laptop Display*/
    @media (min-width: 576px) {
        h1 {
            font-size: calc(2.5rem + 5vmin);
        }
    }

    /*For Mobile Display*/
    @media (max-width: 576px) {
        h1 {
            font-size: calc(1.5rem + 6vmin);
        }
    }
</style>